module.exports = __webpack_public_path__ + "6b66fda572cb6a15a25265fac864d403.fbx";